import React, {useRef, useState, useContext, useEffect} from "react";
import { Avatar, Button } from "antd";
import { AudioOutlined, SettingOutlined, PhoneOutlined, AudioMutedOutlined } from "@ant-design/icons";
import "./Calling.css";
import { SignalRContext } from '../../contexts/SignalRContext';
const Calling = (props: {connectionId: string}) => {
  const localVideoRef = useRef<HTMLVideoElement>(null);
  const remoteVideoRef = useRef<HTMLVideoElement>(null);
  const peerConnection = useRef<RTCPeerConnection | null>(null);
  const signalContext = useContext(SignalRContext);
  const connection = signalContext?.connection;
  const [incomingCall, setIncomingCall] = useState<{ callerName: string, callerEmail: string } | null>(null);
  useEffect(() => {
    connection?.on("ReceiveCallRequest", (callerName, callerEmail) => {
      setIncomingCall({ callerName, callerEmail });
    });
    connection?.on("ReceiveOffer", async (fromId, offer) => {
      await peerConnection.current?.setRemoteDescription(new RTCSessionDescription(offer));
      const answer = await peerConnection.current?.createAnswer();
      await peerConnection.current?.setLocalDescription(answer);
      connection?.invoke("SendAnswer", fromId, answer);
    });

    connection?.on("ReceiveAnswer", async (answer) => {
      await peerConnection.current?.setRemoteDescription(new RTCSessionDescription(answer));
    });

    connection?.on("ReceiveIceCandidate", async (candidate) => {
      await peerConnection.current?.addIceCandidate(new RTCIceCandidate(candidate));
    });
  }, []);

  const startCall = async () => {
    console.log("abv" + props.connectionId);
    peerConnection.current = new RTCPeerConnection({
      iceServers: [{ urls: "stun:stun.l.google.com:19302" }],
    });

    const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
    if (localVideoRef.current) {
      localVideoRef.current.srcObject = stream;
    }
    stream.getTracks().forEach((track) => peerConnection.current?.addTrack(track, stream));

    peerConnection.current.ontrack = (event) => {
      if (remoteVideoRef.current) {
        remoteVideoRef.current.srcObject = event.streams[0];
      }
    };

    peerConnection.current.onicecandidate = (event) => {
      if (event.candidate && connection) {
        connection.invoke("SendIceCandidate", props.connectionId, event.candidate);
      }
    };

    const offer = await peerConnection.current.createOffer();
    await peerConnection.current.setLocalDescription(offer);
    connection?.invoke("SendOffer", props.connectionId , offer);
  };
  const acceptCall = async () => {
      await startCall();
  };
  return (
    <div className="calling-container">
      {/* Ảnh nền làm mờ */}
      <div className="background-blur">
        <video ref={localVideoRef} autoPlay playsInline muted />
      </div>
      {/* Ảnh đại diện và trạng thái */}
      {/* <div className="call-info">
        <Avatar
          size={100}
          src="https://via.placeholder.com/100" // Thay thế bằng ảnh thật
          className="avatar"
        />
        <p className="status">Đang đổ chuông...</p>
      </div> */}
      {/* Thanh điều khiển */}
      <div className="call-controls">
        <Button shape="circle" size="large" icon={<AudioMutedOutlined />} />
        <Button shape="circle" size="large" icon={<PhoneOutlined />} 
        danger className="end-call" onClick={acceptCall} />
        <Button shape="circle" size="large" icon={<AudioOutlined />} />
        <Button shape="circle" size="large" icon={<SettingOutlined />} />
      </div>
    </div>
  );
};
export default Calling;
